import { Api } from '@coderhouse/common'
import { AvailableBalance, IAvailableBalance } from '@/models/available-balance'

const { VUE_APP_API_ENDPOINT } = process.env

async function getAvailableBalances(userId: string): Promise<AvailableBalance[]> {
  const availableBalance: IAvailableBalance[] = await Api.get(
    `${VUE_APP_API_ENDPOINT}/platform/users/${userId}/profile-available-balance`
  )

  return availableBalance.map(ab => new AvailableBalance(ab))
}

export { getAvailableBalances }
